import {
  ActionReducerMapBuilder,
  createAction,
  createReducer,
} from "@reduxjs/toolkit";
import { WizardState, WizardForm } from "@marta/core/types";

export const setRestructuredWizard = createAction<WizardState>(
  "wizard/setRestructured",
);
export const updateRestructuredForm = createAction<{
  formKey: string;
  newForm: WizardForm;
  stats: WizardState["stats"];
  nextWizardForm: WizardState["nextWizardForm"];
}>("wizard/updateForm");

export const initialRestructuredState: { restructured: WizardState | null } = {
  restructured: null,
};

export const createRestructuredSlice = <State>(options: {
  initialState: State;
  reducers?: (
    builder: ActionReducerMapBuilder<State & typeof initialRestructuredState>,
  ) => void;
}) => {
  const reducer = createReducer(
    Object.assign({}, initialRestructuredState, options.initialState),
    (builder) => {
      builder
        .addCase(setRestructuredWizard, (state, action) => {
          state.restructured = action.payload;
        })
        .addCase(updateRestructuredForm, (state, action) => {
          if (state.restructured) {
            const { formKey, newForm, stats, nextWizardForm } = action.payload;
            state.restructured.structuredForms[formKey] = newForm;
            state.restructured.stats = stats;
            state.restructured.nextWizardForm = nextWizardForm;
          }
        });

      if (options?.reducers) options.reducers(builder);
    },
  );

  return { reducer, getInitialState: reducer.getInitialState };
};
